import { LoadError } from '@/components/LoadError';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { useArchiveGoal, useArchiveProject, useGoals, useProjects } from '@/lib/queries';

/**
 * Архив, а не корзина: содержимое цели и проекта остаётся на месте, меняется
 * только видимость (ROADMAP, Этап 2).
 */
export default function ArchivePage() {
  const { t } = useTranslation();
  const goals = useGoals(true);
  const projects = useProjects(true);
  const restoreGoal = useArchiveGoal();
  const restoreProject = useArchiveProject();

  const empty = goals.data?.length === 0 && projects.data?.length === 0;

  return (
    <section className="flex flex-col gap-6">
      <div>
        <Link to="/goals" className="text-sm text-muted hover:text-ink">
          ← {t('goals.title')}
        </Link>
        <h1 className="mt-2 font-serif text-2xl font-semibold">{t('archive.title')}</h1>
      </div>

      {(goals.isError || projects.isError) && (
        <LoadError retry={() => Promise.all([goals.refetch(), projects.refetch()])} />
      )}
      {(goals.isPending || projects.isPending) && <p role="status">{t('common.loading')}</p>}
      {empty && <p className="text-sm text-muted">{t('archive.empty')}</p>}

      {goals.data && goals.data.length > 0 && (
        <section className="flex flex-col gap-2" aria-label={t('goals.title')}>
          <h2 className="text-sm font-medium text-ink-2">{t('goals.title')}</h2>
          <ul className="flex flex-col gap-2">
            {goals.data.map((goal) => (
              <li
                key={goal.id}
                className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-line bg-surface px-4 py-3"
              >
                <Link to={`/goals/${goal.id}`} className="min-w-0 break-words">
                  {goal.title}
                </Link>
                <Button
                  size="sm"
                  onClick={() => restoreGoal.mutate({ id: goal.id, archived: false })}
                >
                  {t('archive.restore')}
                </Button>
              </li>
            ))}
          </ul>
        </section>
      )}

      {projects.data && projects.data.length > 0 && (
        <section className="flex flex-col gap-2" aria-label={t('goal.projects')}>
          <h2 className="text-sm font-medium text-ink-2">{t('goal.projects')}</h2>
          <ul className="flex flex-col gap-2">
            {projects.data.map((project) => (
              <li
                key={project.id}
                className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-line bg-surface px-4 py-3"
              >
                <Link to={`/projects/${project.id}`} className="min-w-0 break-words">
                  {project.title}
                </Link>
                <Button
                  size="sm"
                  onClick={() => restoreProject.mutate({ id: project.id, archived: false })}
                >
                  {t('archive.restore')}
                </Button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
